// extracted by mini-css-extract-plugin
export default {"main":"src-containers-layouts-main-styles-main-0OJww"};